'use strict';
(function () {
    function png2GridData(options) {
        const { url, data: headerData, newData } = options
        return new Promise(resolve => {

            const data = [{
                header: {
                    "min": -99,
                    "max": 99999,
                    "dx": (headerData.right - headerData.left) / headerData.cols,
                    "dy": (headerData.top - headerData.bottom) / headerData.rows,
                    "forecastTime": 1,
                    "left": headerData.top,
                    "top": headerData.left,
                    // "left": headerData.top,
                    // "top": headerData.left,
                    "cols": headerData.cols,
                    "rows": headerData.rows,
                },
                data: newData
            }]
            resolve(data)
            // }
        })
    }

    function isValue(x) {
        return x !== null && x !== undefined
    }

    function colorInterpolator(pre, next) {
        const r = pre[0],
            g = pre[1],
            b = pre[2],
            a = pre[3],
            rDiff = next[0] - r,
            gDiff = next[1] - g,
            bDiff = next[2] - b,
            aDiff = next[3] - a
        return function (proportion, alpha) {
            return [
                Math.floor(r + proportion * rDiff),
                Math.floor(g + proportion * gDiff),
                Math.floor(b + proportion * bDiff),
                Math.floor(a * 1000),
                // alpha,
            ]
        }
    }

    function floorMod(a, n) {
        return a - n * Math.floor(a / n)
    }

    function clamp(value, range) {
        return Math.max(range[0], Math.min(value, range[1]))
    }

    function proportion(value, low, high) {
        return (clamp(value, [low, high]) - low) / (high - low)
    }

    function segmentColorScale(gradient) {
        let colors = []
        let colorInterpolators = []
        let colorRanges = []
        for (let i = 0; i < gradient.length - 1; i++) {
            colors.push(gradient[i + 1][0])
            colorInterpolators.push(
                colorInterpolator(gradient[i][1], gradient[i + 1][1])
            )
            colorRanges.push([gradient[i][0], gradient[i + 1][0]])
        }
        return function (value, alpha) {
            for (var i = 0; i < colors.length - 1 && !(value <= colors[i]); i++);
            const range = colorRanges[i]
            return colorInterpolators[i](proportion(value, range[0], range[1]), alpha)

        }
    }

    L.TilePixelLayer = L.TileLayer.extend({
        options: {
            data: null,
            overlayAlpha: 230,
            gap: 2,
            zIndex: 7,
            gradient: []
        },
        map: null,
        builder: null,
        grid: null,
        gridDataBuilt: null,
        date: null,
        replaceNaN: true,
        replaceNaNValue: 0,
        λ0: null,
        φ0: null,
        Δλ: null,
        Δφ: null,
        ni: null,
        nj: null,
        initialize: function (options) {
            L.setOptions(this, options)
            this.gradient = segmentColorScale(options.gradient)
        },
        createTile: function (coords) {
            const dom = L.DomUtil.create('canvas', 'leafvar-pixel-tile')
            const size = this.getTileSize()
            dom.width = size.x
            dom.height = size.y
            const ctx = dom.getContext('2d')
            const bounds = {
                x: coords.x * dom.width,
                y: coords.y * dom.height,
                z: coords.z,
                w: dom.width,
                h: dom.height
            }
            this.interpolateField(ctx, bounds)
            return dom
        },
        onAdd: function (map) {

            const that = this
            this.map = map
            png2GridData(this.options).then(res => {
                this.buildGrid(res)
                setTimeout(() => {
                    this.map.on('click', e => {
                        const { latlng } = e
                        const { lat, lng } = latlng
                        const gridValue = that.gridDataBuilt.interpolate(lng, lat)
                        this.options.clickEvt && this.options.clickEvt(e, gridValue)
                    })
                }, 1000)
                L.TileLayer.prototype.onAdd.call(this, map)
            })
        },
        onRemove: function (map) {
            /*  这句话注释了，因为如果清空这个，绘制之后，
             莫名其妙也会变成null，导致缩放会报错卡顿 */
            // this.gridDataBuilt = null
            this.map.off('click')
            L.TileLayer.prototype.onRemove.call(this, map)
        },
        createBuilder: function (data) {
            const that = this
            return {
                header: data.header,
                data: function (i) {
                    return data.data[i]
                },
                interpolate: that.bilinearInterpolateScalar
            }
        },
        buildGrid: function (gridData) {

            const that = this
            this.builder = this.createBuilder(gridData[0])
            const header = this.builder.header
            this.λ0 = header.top
            this.φ0 = header.left
            this.Δλ = header.dx
            this.Δφ = header.dy
            this.ni = header.cols
            this.nj = header.rows
            this.date = new Date(header.refTime)
            this.date.setHours(this.date.getHours() + header.forecastTime)
            this.grid = []
            for (let i = 0, y = 0; y < this.nj; y++) {
                let result = []
                for (let x = 0; x < this.ni; x++, i++) {
                    result[x] = this.builder.data(i)
                    if (this.replaceNaN && isNaN(result[x])) {
                        result[x] = this.replaceNaNValue
                    }
                }
                result.push(result[0])
                this.grid[y] = result
            }
            that.gridDataBuilt = {
                date: this.date,
                interpolate: function (λ, φ) {
                    if (!that.grid) return null
                    const i = floorMod(λ - that.λ0, 360) / that.Δλ
                    const j = (that.φ0 - φ) / that.Δφ

                    const fi = Math.floor(i),
                        ci = fi + 1
                    const fj = Math.floor(j),
                        cj = fj + 1
                    let row

                    if ((row = that.grid[fj])) {
                        const g00 = row[fi]
                        const g10 = row[ci]

                        if (isValue(g00) && isValue(g10) && (row = that.grid[cj])) {
                            const g01 = row[fi]
                            const g11 = row[ci]

                            if (isValue(g01) && isValue(g11)) {
                                return Number(that.builder.interpolate(i - fi, j - fj, g00, g10, g01, g11).toFixed(2))
                            }
                        }
                    }

                    return null
                }
            }
        },
        pointToCoord: function (x, y, zoom) {
            const location = this.map.unproject(L.point(x, y), zoom)
            return [location.lng, location.lat]
        },
        createMask: function (ctx, bounds) {
            if (!ctx) return null
            const width = bounds.w
            const height = bounds.h
            const imageData = new ImageData(width, height)
            const imageDataRaw = imageData.data
            return {
                imageData: imageData,
                set: function (x, y, color) {
                    const index = 4 * (y * width + x)
                    imageDataRaw[index] = color[0]
                    imageDataRaw[index + 1] = color[1]
                    imageDataRaw[index + 2] = color[2]
                    imageDataRaw[index + 3] = color[3]
                    return this
                }
            }
        },
        bilinearInterpolateScalar: function (x, y, g00, g10, g01, g11) {
            const rx = 1 - x
            const ry = 1 - y
            return g00 * rx * ry + g10 * x * ry + g01 * rx * y + g11 * x * y
        },
        interpolateField: function (ctx, bounds, render) {
            const that = this
            let x = bounds.x
            let tileX = 0
            const gap = 4
            const xGap = this.map.getZoom() <= 4 ? (gap > 2 ? 2 : gap) : gap
            const yGap = xGap
            const mask = this.createMask(ctx, bounds)

            function interpolateColumn(x, tileX) {
                for (
                    let defaultColor = [0, 0, 0, 0], y = bounds.y, height = 0; height <= bounds.h; y += yGap, height += yGap
                ) {
                    let color = defaultColor
                    const coord = that.pointToCoord(x, y, bounds.z)
                    if (coord) {
                        const λ = coord[0]
                        const φ = coord[1]
                        if (isFinite(λ)) {
                            const gridValue = that.gridDataBuilt.interpolate(λ, φ)
                            if (isValue(gridValue)) {
                                color = that.gradient(gridValue, that.options.overlayAlpha)
                            }
                        }
                    }
                    for (let i = 0; i < xGap; i++) {
                        for (let j = 0; j < yGap; j++) {
                            mask.set(tileX + i, height + j, color)
                        }
                    }
                }
            }

            var batchInterpolate = () => {
                const start = Date.now()

                while (tileX < bounds.w) {
                    interpolateColumn(x, tileX)
                    x += xGap
                    tileX += xGap

                    if (Date.now() - start > 500) {
                        setTimeout(batchInterpolate, 25)
                        return
                    }
                }

                ctx.putImageData(mask.imageData, 0, 0)
            }

            batchInterpolate()
        }
    })

    L.tilePixelLayer = function (options) {
        return new L.TilePixelLayer(options)
    }
})()
